// https://github.com/michu2k/Accordion
import Accordion from 'accordion-js';

const accordionComponent = () => {
    const accordions = Array.from(document.querySelectorAll('.accordion__items'));

    if (!accordions.length) {
        return;
    }
    // Init with options
    new Accordion(accordions, {
        duration: 400,
        showMultiple: true,
        elementClass: 'accordionItem',
        triggerClass: 'accordionItem__target',
        panelClass: 'accordionItem__content',
        onOpen: (currElement) => {
            // if current element has data attribute data-has-image="true"
            // if (currElement.dataset.hasImage === 'true') {
            //     const content = currElement.querySelector('.accordionItem__contentInner');

            //     // set min height of current element
            //     content.style.minHeight = '160px';
            // }

            
        },
        // onClose: (currElement) => {
        //     window.dispatchEvent(new Event('resize'));
        // }
    });
};



/**
 * Function to run when this module is called from site.js
 */
const init = () => {

    accordionComponent();

};

export default init;
